import { HOUSE_DISPOSITION_OPTIONS } from "../constants";

export const NEUTRAL_DISPOSITION_COLOR = "#A9A9A9";

export const getDefaultDispositionColor = (value) =>
  HOUSE_DISPOSITION_OPTIONS.find((option) => option.value === value)?.color || NEUTRAL_DISPOSITION_COLOR;

export const getDispositionOptions = (dataProperty) => {
  const matches = (dataProperty || []).filter((data) => data?.name === "household_disposition");
  const options = (matches.find((data) => data.objectType === "household") || matches[0])?.options;
  const visible = (options || []).filter((option) => !option.hidden && option.value);
  if (!visible.length) return HOUSE_DISPOSITION_OPTIONS;
  return visible.map((option) => ({ value: option.value, label: option.label || option.value }));
};

export const getDispositionColor =(value, tenantColors) =>
  tenantColors?.[value] || getDefaultDispositionColor(value);
